import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {subWeeks} from "date-fns";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function ({ filters, setFilters}) {
    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                />
            </form>
        </div>
    )
}